<script>
import { IconArrowRightCircle } from "@tabler/icons-vue";

export default {
	name: "ValueChange",
	components: {IconArrowRightCircle},
	props: {
		from: {
			type: String,
		},
		to: {
			type: String,
		}
	},
}
</script>

<template>
	<div class="flex items-center gap-x-2">
		<p class="truncate text-surface-500">
			{{ from ?? $t('common.na') }}
		</p>

		<IconArrowRightCircle :stroke-width="2" class="text-surface-400"/>

		<p class="whitespace-nowrap text-surface-700 font-bold">
			{{ to }}
		</p>
	</div>
</template>

<style scoped>
</style>